module.exports = "https://web-assets.ifttt.com/packs/media/header/return_key_icon_white-b6f9896b.svg";